import { useState, useCallback, memo } from 'react'
import AsyncSelect from 'react-select/async'

import { FilteredType } from './filter'

interface FilterSelectProps {
  options: FilteredType[]
  placeholder?: string
  isLoading: boolean
  addToExpression: (expression: FilteredType) => void
  value: string
}

const FilterSelect = ({
  options,
  placeholder,
  isLoading,
  addToExpression,
  value,
}: FilterSelectProps) => {
  const [isDisabled, setIsDisabled] = useState(() => {
    if (value) return true
    return false
  })
  const loadOptions = useCallback(
    (inputValue: string, callback: (options: FilteredType[]) => void) => {
      const filteredOptions = options?.filter(
        option => option.label && option.label.toLowerCase().includes(inputValue.toLowerCase()),
      )
      callback(filteredOptions)
    },
    [options],
  )

  const sendElement = (option: FilteredType) => {
    addToExpression(option)
    setIsDisabled(true)
  }

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={options}
      loadOptions={loadOptions}
      onChange={option => {
        sendElement(option as FilteredType)
      }}
      placeholder={value || placeholder}
      styles={{
        control: baseStyles => ({
          ...baseStyles,
          width: '170px',
          '@media (max-width: 768px)': {
            width: '100%',
          },
        }),
        valueContainer: baseStyles => ({
          ...baseStyles,
          maxHeight: '35px',
        }),
        menuList: baseStyles => ({
          ...baseStyles,
          maxHeight: '150px',
          overflowX: 'hidden',
        }),
      }}
      noOptionsMessage={() => 'Sem resultados'}
      isLoading={isLoading}
      isDisabled={isDisabled}
      menuShouldScrollIntoView={false}
    />
  )
}

export default memo(FilterSelect)
